module.exports = __webpack_public_path__ + "static/img/weather_008.a8bae4f3.svg";